import React from 'react';
import moment from 'moment';
import './item-transporte.css';

const getDate = (value, format, returnedText = '', appendedText = '') => {
  if (
    value === null
    || value === '0001-01-01T00:00:00'
    || value === undefined
  ) {
    return returnedText;
  }

  if (format.toUpperCase().includes('H') && value.includes('00:00:00')) {
    return returnedText;
  }

  return `${moment(value).format(format)} ${appendedText}`;
};
// const getDuration = (start, end) => {
//   const parsedStart = moment(start);
//   const parsedEnd = moment(end);

//   const duracion = moment.duration(parsedStart.diff(parsedEnd));
//   const horas = moment.duration(duracion).asHours();
//   const minutos = moment.duration(duracion).minutes();

//   return `${ Math.floor(horas) }h ${ minutos }m`;
// };

const ItemTransporte = (props) => {
  const { segmento } = props;
  const diaS = getDate(segmento.fechaSalida, 'ddd D');
  const mesS = getDate(segmento.fechaSalida, 'MMM YYYY');
  const diaL = getDate(segmento.fechaLlegada, 'ddd D');
  const mesL = getDate(segmento.fechaLlegada, 'MMM YYYY');
  const horaS = getDate(segmento.horaSalida, 'HH:mm');
  const horaL = getDate(segmento.horaLlegada, 'HH:mm');
  return (
    <div className='box-seg'>
      <div className='item-content in-left'>
        <span className='container-icon color-dinamico-fondo'>
          <i className='fa fa-arrow-right' />
        </span>
        <span>
          <span className='uppercase'>{diaS}</span>
          &nbsp;
          <span className='uppercase'>{mesS}</span>
        </span>
        <i className='fa fa-chevron-right' style={{ padding: '0 9px' }} />
      </div>
      <div className='item-content middle'>
        <span className='internal-items'>
          <b>
            {horaS}
            {' '}
            hs
            {' '}
            {segmento.ciudadOrigenIata}
          </b>
          {' '}
          -
          <b>
            {horaL}
            {' '}
            hs
            {' '}
            {segmento.ciudadDestinoIata}
          </b>
        </span>
      </div>
      <div className='item-content in-left'>
        <i className='fa fa-chevron-right' style={{ padding: '0 9px' }} />
        <span className='container-icon color-dinamico-fondo'>
          <i className='fa fa-arrow-left ' />
        </span>
        <span>
          <span className='uppercase'>{diaL}</span>
          &nbsp;
          <span className='uppercase'>{mesL}</span>
        </span>
      </div>
    </div>
  );
};
export default ItemTransporte;

// array de props.segmento:
// aeropuertoLlegada: null
// aeropuertoOrigen: null
// ciudadDestinoDescripcion: "LIM"
// ciudadDestinoIata: "LIM"
// ciudadOrigenDescripcion: "BUE"
// ciudadOrigenIata: "BUE"
// duracion: 0
// fechaLlegada: "2020-01-11T00:00:00"
// fechaSalida: "2020-01-11T00:00:00"
// horaLlegada: "2019-08-09T08:40:00"
// horaSalida: "2019-08-09T06:03:00"
// paisDestinoDescripcion: null
// paisDestinoIata: null
// paisOrigenDescripcion: null
// paisOrigenIata: null
